import { DirectiveFunction, VNode } from 'vue'
import { DirectiveBinding } from 'vue/types/options'

export const VVtTesting: DirectiveFunction = (el: HTMLElement, binding: DirectiveBinding, vnode: VNode) => {
    // Transform component context to kebap case format
    const tagNameKebapCase = vnode.context?.$options.name?.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase() ?? ''

    // The description will be a field that we pass from outside to the directive
    const description = binding.value ?? 'test'

    // Component where the directive is applied. For example if it is a b-button, the label name will be button not b-button
    const tagName = el.localName

    // Add the qa attribute with the corresponding text to the element where the directive is applied
    el.setAttribute('qa', `${tagNameKebapCase}-${description}-${tagName}`)
}
